import axios from "axios";

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;
const authHeaders = (token) => ({ Authorization: `Bearer ${token}` });

export async function fetchUtmCampaigns(token) {
  const response = await axios.get(`${API_BASE}/admin/utm-campaigns`, { headers: authHeaders(token) });
  return response.data;
}

export async function createUtmCampaign(token, payload) {
  const response = await axios.post(`${API_BASE}/admin/utm-campaigns`, payload, { headers: authHeaders(token) });
  return response.data;
}

export async function updateUtmCampaign(token, campaignId, payload) {
  const response = await axios.put(`${API_BASE}/admin/utm-campaigns/${campaignId}`, payload, { headers: authHeaders(token) });
  return response.data;
}

export async function deleteUtmCampaign(token, campaignId) {
  const response = await axios.delete(`${API_BASE}/admin/utm-campaigns/${campaignId}`, { headers: authHeaders(token) });
  return response.data;
}